import CommanForm from '../../../components/FormController/Commanform';
import ContactSupportValidation from '../../../yup/Dashboard/ContactSupport/ContactValidation';
import Errormessages from '../../../components/ErrorMessage/Errormessages';
import Button from '../../../components/Ui/Button';
import CommanPhoneNumber from '../../../components/Ui/PhoneNumber';
import { useDispatch, useSelector } from 'react-redux';
import { ContactSupportAction } from '../../../redux/Action/DashboardAction';
import { StorageConstants } from '../../../constants/Constants';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { useIntl } from 'react-intl';
import { sidebarOpen } from '../../../utils/Helper';

const CustomerSupport = () => {
    const intl = useIntl();

    const dispatch = useDispatch<any>();
    const ContactState = useSelector((state: any) => state.ContactSupportState);
    const navigate = useNavigate()

    const { register, setValue, trigger, errors, handleSubmit } = CommanForm({
        validationSchema: ContactSupportValidation, defaultValues: { name: '', email: '', phone_number: '', description: '' }
    });



    const handlePhoneNumber = (value: any, code: any, phone: any) => {
        setValue('phone_country_code', code?.dialCode)
        setValue('phone_number', phone)
        trigger("phone_number")
    }

    const onSubmit = (payload: any) => {
        let data = {
            ...payload,
            phone_country_code: "+" + payload?.phone_country_code,
            user_type: StorageConstants?.USERTYPE
        }
        dispatch(ContactSupportAction(data))
    }
    useEffect(() => {
        if (ContactState?.status) {
            navigate('/dashboard')
        }
    }, [ContactState])

    useEffect(() => {
        return () => {
            dispatch(ContactSupportAction("RESET"))
        }
    }, [])


    return (
        <>
            <div className='col-lg-9'>
                <div className='dashboard bg-white'>
                    <div className='dashboardTop'>
                        <h2><button type='button' onClick={() => { sidebarOpen() }} className='btn mobileMenu p-1 d-lg-none'><span className="icon-menu-right"></span></button> <FormattedMessage id="customer_support" /></h2>
                    </div>
                    <div className='sameGap'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='row'>
                                <div className='col-md-5 col-lg-5'>
                                    <div className='normalINput mb-3'>
                                        <label className="form-label"><FormattedMessage id="username" /></label>
                                        <input type="text" className="form-control"
                                            placeholder={intl.formatMessage({ id: 'enter_name' })}

                                            {...register("name")}
                                            onInput={(e: any) => {
                                                const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                setValue("name", value);
                                            }}

                                        />
                                        <Errormessages errors={errors} name="name" />
                                    </div>

                                    <div className='normalINput mb-3'>
                                        <label className="form-label"><FormattedMessage id="email_address" />*</label>
                                        <input type="email" className="form-control" placeholder={intl.formatMessage({ id: 'enter_email_address' })}
                                            {...register("email")} />
                                        <Errormessages errors={errors} name="email" />
                                    </div>

                                    <div className='ReactnormalINput mb-3'>
                                        <label className="form-label"><FormattedMessage id="phone_number" /></label>
                                        <CommanPhoneNumber handleMobileNumber={handlePhoneNumber} />    
                                        <Errormessages errors={errors} name="phone_number" />
                                    </div>

                                    <div className='normalINput mb-3'>
                                        <label className="form-label"><FormattedMessage id="message" />*</label>
                                        <textarea className="form-control" placeholder={intl.formatMessage({ id: 'please_enter_messsage' })} rows={4} {...register("description")}

                                            onInput={(e: any) => {
                                                const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                setValue("description", value);
                                            }}></textarea>
                                        <Errormessages errors={errors} name="description" />
                                    </div>
                                    <Button type="submit" text={<FormattedMessage id="send_message" /> as any} className='btn btn-fill my-4 w-100' isLoading={ContactState?.loading} />
                                </div>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </>
    )
}

export default CustomerSupport